module.exports = __webpack_public_path__ + "static/kw51_img_3-783e636d3391d616c57f7ef5e26e79f4.png";